/**
 * @license
 *
 * Copyright IBM Corp. 2022, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { property } from 'lit/decorators.js';
import ArrowRight20 from '@carbon/web-components/es/icons/arrow--right/20.js';
import ArrowLeft20 from '@carbon/web-components/es/icons/arrow--left/20.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import C4DMegaMenuHeading from './megamenu-heading';
import styles from './masthead.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * MegaMenu Category Heading.
 *
 * @element c4d-megamenu-category-heading
 * @csspart l0-arrow-cat-heading -  Targets the heading category arrow icon. Usage: `c4d-megamenu-category-heading::part(l0-arrow-cat-heading)`
 */
@customElement(`${c4dPrefix}-megamenu-category-heading`)
class C4DMegaMenuCategoryHeading extends C4DMegaMenuHeading {
  protected get _arrowIcon() {
    const isRTL = document.dir.toLowerCase() === 'rtl';
    return isRTL
      ? ArrowLeft20({ part: 'l0-arrow-cat-heading' })
      : ArrowRight20({ part: 'l0-arrow-cat-heading' });
  }

  @property({ reflect: true, type: Number, attribute: 'heading-level' })
  headingLevel = 3;

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

export default C4DMegaMenuCategoryHeading;
